export default {
  'SET_START_REGISTER_RESPONSE'(state, data) {
    state.startRegisterResponse = data;
  }
};
